import { combineReducers } from "redux";
import EquityQuote from "./EquityQuotes/EquityQuote";
import FutureQuotes from "./FutureQuotes/FutureQuotes";
import IndicesQuotes from "./IndicesQuotes/IndicesQuotes";
import MutualFundsQuotes from "./MutualFundsQuotes/MutualFundsQuotes";
export default combineReducers({
    EquityQuote,
    FutureQuotes,
    IndicesQuotes,
    MutualFundsQuotes,
});
